import {mergeRouteMeta} from '../start-ui';

let app = null;
let registeredServices = {};
let loadedServices = [];

export function register(name, service) {
    if (registeredServices.hasOwnProperty(name)) {
        throw `A service with the name '${name}' is already registered.`;
    }
    if (typeof service === "function") {
        service = {initial: service};
    } else if (typeof service !== "object") {
        throw `Second argument needs to be function or object.`;
    }
    registeredServices[name] = service;
}

export function load(serviceNames) {
    let all = [];

    if (!Array.isArray(serviceNames)) {
        serviceNames = [serviceNames];
    }

    for (let name of serviceNames) {
        if (!registeredServices.hasOwnProperty(name)) {
            throw `Unknown service '${name}'`;
        }
        let service = registeredServices[name];

        if (service.hasOwnProperty('initial') && !loadedServices.includes(name)) {
            all.push(service.initial.call(app));
            loadedServices.push(name);
        }

        if (service.hasOwnProperty('always')) {
            all.push(service.always.call(app));
        }
    }

    return Promise.all(all);
}

export default {
    defaultConfig: {
        services: {},
    },

    install(Vue, {router, services, autoBindGuard = true}) {
        app = Vue;

        if (autoBindGuard) {
            bindProviderRouterGuard(Vue, router);
        }

        Vue.$provider = Vue.prototype.$provider = {register, load};
        Object.entries(services).forEach(([name, callback]) => register(name, callback));
    },
};

export function bindProviderRouterGuard(Vue, router) {
    router.beforeEach(async (to, from, next) => {
        let {services} = mergeRouteMeta(to);
        if (Array.isArray(services)) {
            await load(services);
        }
        next();
    });
}